import * as userApi from '../common/api/user';

export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const fetchUserDetails = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_DETAILS });

  try {
    const details = await userApi.fetchUserDetails();
    dispatch({
      type: FETCH_USER_DETAILS_SUCCESS,
      details,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_DETAILS_FAILURE,
      error: err,
    });
  }
};

export const FETCH_USER_ENTITLEMENTS = 'FETCH_USER_ENTITLEMENTS';
export const FETCH_USER_ENTITLEMENTS_SUCCESS = 'FETCH_USER_ENTITLEMENTS_SUCCESS';
export const FETCH_USER_ENTITLEMENTS_FAILURE = 'FETCH_USER_ENTITLEMENTS_FAILURE';

export const fetchUserEntitlements = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_ENTITLEMENTS });

  try {
    const { entitlements } = await userApi.fetchUserEntitlements();
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_SUCCESS,
      entitlements,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_FAILURE,
      error: err,
    });
  }
};


export const FETCH_USER_FAVORITES = 'FETCH_USER_FAVORITES';
export const FETCH_USER_FAVORITES_SUCCESS = 'FETCH_USER_FAVORITES_SUCCESS';
export const FETCH_USER_FAVORITES_FAILURE = 'FETCH_USER_FAVORITES_FAILURE';

export const fetchUserFavorites = clientIp => async (dispatch) => {
  dispatch({ type: FETCH_USER_FAVORITES });
  try {
    const { data } = await userApi.fetchUserFavorites(clientIp);
    const { favorites } = data;
    dispatch({
      type: FETCH_USER_FAVORITES_SUCCESS,
      favorites,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_FAVORITES_FAILURE,
      error: err,
    });
  }
};

export const SET_FAVORITED = 'SET_FAVORITED';
export const SET_FAVORITED_SUCCESS = 'SET_FAVORITED_SUCCESS';
export const SET_FAVORITED_FAILURE = 'SET_FAVORITED_FAILURE';

export const toggleFavorite = (favorited = true, favoriteId) => async (dispatch, getState) => {
  dispatch({ type: SET_FAVORITED });

  try {
    let favorites;
    // POST or DELETE specified favorite
    if (favorited) {
      await userApi.postUserFavorite(favoriteId);

      // Refetch favorites to cascade change into state
      const { data } = await userApi.fetchUserFavorites();
      favorites = data.favorites;
    } else {
      await userApi.deleteUserFavorite(favoriteId);
      const favoritesInState = getState().user.favorites;
      favorites = favoritesInState.filter(favorite => favorite._id !== favoriteId);
    }

    dispatch({
      type: SET_FAVORITED_SUCCESS,
      favorites,
    });
  } catch (err) {
    dispatch({
      type: SET_FAVORITED_FAILURE,
      error: err,
    });
  }
};

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS';
export const FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS';
export const FETCH_USER_SETTINGS_FAILURE = 'FETCH_USER_SETTINGS_FAILURE';

export const fetchUserSettings = clientIp => async (dispatch) => {
  dispatch({ type: FETCH_USER_SETTINGS });

  try {
    const settings = await userApi.fetchUserSettings(clientIp);
    dispatch({
      type: FETCH_USER_SETTINGS_SUCCESS,
      settings,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_SETTINGS_FAILURE,
      error: err,
    });
  }
};


export const SET_RECENTLY_VISITED = 'SET_RECENTLY_VISITED';

export const setRecentlyVisited = (type, _id, name) => async (dispatch) => {
  try {
    const { recentlyVisited } = await userApi.postRecentlyVisited({ type, _id, name });
    dispatch({
      type: SET_RECENTLY_VISITED,
      recentlyVisited,
    });
  } catch (err) {
    // Ignore this error.
  }
};



// WEBPACK FOOTER //
// ./src/actions/user.js